export default "__VITE_ASSET__Cd4WbD5x__"